module.exports = __webpack_public_path__ + "img/背景.8091cfa4.png";